import _copyObject_default from "./_copyObject.js";
import _getSymbols_default from "./_getSymbols.js";

//#region ../../node_modules/lodash-es/_copySymbols.js
/**
* Copies own symbols of `source` to `object`.
*
* @private
* @param {Object} source The object to copy symbols from.
* @param {Object} [object={}] The object to copy symbols to.
* @returns {Object} Returns `object`.
*/
function copySymbols(source, object) {
	return _copyObject_default(source, _getSymbols_default(source), object);
}
var _copySymbols_default = copySymbols;

//#endregion
export { _copySymbols_default as default };
//# sourceMappingURL=_copySymbols.js.map